import { COLOR } from 'vars/index'

export const TextBoxTypes = {
  HeadlineExtra5: `--fonts-headline-extra-5`,
  HeadlineExtra10: `--fonts-headline-extra-10`,
  Headline1: `--fonts-headline-1`,
  Headline2: `--fonts-headline-2`,
  Headline3: `--fonts-headline-3`,
  Headline4: `--fonts-headline-4`,
  Footnote1: `--fonts-footnote-1`,
  Footnote2: `--fonts-footnote-2`,
  Footnote3: `--fonts-footnote-3`,
  Footnote4: `--fonts-footnote-4`,
  Footnote5: `--fonts-footnote-5`,
  Footnote6: `--fonts-footnote-6`,
  Body1: `--fonts-body-1`,
  Body2: `--fonts-body-2`,
  Body3: `--fonts-body-3`,
  Body4: `--fonts-body-4`,
  Body5: `--fonts-body-5`,
  Caption1: `--fonts-caption-1`,
  Caption2: `--fonts-caption-2`,
  Caption3: `--fonts-caption-3`,
  Caption4: `--fonts-caption-4`,
  Caption5: `--fonts-caption-5`,
  Button1: `--fonts-button-1`,
  Button2: `--fonts-button-2`,
  Font5xl: `--fonts-font-5-xl`,
  Font5xlBold: `--fonts-font-5-xl-bold`,
  Font4xl: `--fonts-font-4-xl`,
  Font4xlBold: `--fonts-font-4-xl-bold`,
  Font3xl: `--fonts-font-3-xl`,
  Font3xlBold: `--fonts-font-3-xl-bold`,
  Font2xl: `--fonts-font-2-xl`,
  Font2xlBold: `--fonts-font-2-xl-bold`,
  FontXl: `--fonts-font-xl`,
  FontXlBold: `--fonts-font-xl-bold`,
  FontLg: `--fonts-font-lg`,
  FontLgBold: `--fonts-font-lg-bold`,
  FontSm: `--fonts-font-sm`,
  FontSmBold: `--fonts-font-sm-bold`,
  FontMdToSm: `--fonts-font-md-to-sm`,
  FontMdToSmBold: `--fonts-font-md-to-sm-bold`,
  FontXs: `--fonts-font-xs`,
  FontXsBold: `--fonts-font-xs-bold`,
} as const
export type TextBoxTypes = (typeof TextBoxTypes)[keyof typeof TextBoxTypes]

export const TextTransform = {
  Uppercase: 'uppercase',
  Lowercase: 'lowercase',
  Capitalize: 'capitalize',
  None: 'none',
} as const
export type TextTransform = (typeof TextTransform)[keyof typeof TextTransform]

export const TextDecoration = {
  Underline: 'underline',
} as const
export type TextDecoration =
  (typeof TextDecoration)[keyof typeof TextDecoration]

export const TextAligning = {
  Left: 'left',
  Right: 'right',
  Center: 'center',
  Stretch: 'justify',
} as const
export type TextAligning = (typeof TextAligning)[keyof typeof TextAligning]

export const WordBreak = {
  Normal: 'normal',
  BreakAll: 'break-all',
  BreakWord: 'break-word',
  KeepAll: 'keep-all',
} as const
export type WordBreak = (typeof WordBreak)[keyof typeof WordBreak]

export const Colors = {
  TEXT_ICON_PRIMARY: COLOR.TEXT_ICON_PRIMARY,
  TEXT_ICON_TERTIARY: COLOR.TEXT_ICON_TERTIARY,
  TEXT_ICON_SECONDARY: COLOR.TEXT_ICON_SECONDARY,
  SURFACE_DARK_7: COLOR.SURFACE_DARK_7,
  TEXT_ICON_CONSTANT_LIGHT: COLOR.TEXT_ICON_CONSTANT_LIGHT,
  TEXT_ICON_CONSTANT_DARK: COLOR.TEXT_ICON_CONSTANT_DARK,
  BASE_MAIN_DEFAULT: COLOR.BASE_MAIN_DEFAULT,
  SURFACE_LIGHT_2: COLOR.SURFACE_LIGHT_2,
  BASE_MAIN_PRESSED: COLOR.BASE_MAIN_PRESSED,
  ACCENT_TERTIARY: COLOR.ACCENT_TERTIARY,
  ADDITIONAL_RED_2: COLOR.ADDITIONAL_RED_2,
} as const
export type Colors = (typeof Colors)[keyof typeof Colors]
